import { Control, useController } from 'react-hook-form';

import { LaunchDetailsFormValues } from './types';
import {
  createEmailValidator,
  createMaxLengthValidator,
  createUrlValidator,
  isRequired,
  isValidInput,
} from '../../validators';

export const useControllers = (
  control: Control<LaunchDetailsFormValues, any, LaunchDetailsFormValues>
) => {
  const {
    field: {
      value: actionTriggerMessages,
      onChange: setActionTriggerMessages,
      onBlur: validateActionTriggerMessages,
    },
    fieldState: { error: actionTriggerMessagesError },
  } = useController({
    control,
    name: 'actionTriggerMessages',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2000),
      },
    },
  });
  const {
    field: {
      value: messageTypes,
      onChange: setMessageTypes,
      onBlur: validateMessageTypes,
    },
    fieldState: { error: messageTypesError },
  } = useController({
    control,
    name: 'messageTypes',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2000),
      },
    },
  });
  const {
    field: {
      value: optinFlow,
      onChange: setOptinFlow,
      onBlur: validateOptinFlow,
    },
    fieldState: { error: optinFlowError },
  } = useController({
    control,
    name: 'optinFlow',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2000),
      },
    },
  });
  const {
    field: {
      value: optoutFlow,
      onChange: setOptoutFlow,
      onBlur: validateOptoutFlow,
    },
    fieldState: { error: optoutFlowError },
  } = useController({
    control,
    name: 'optoutFlow',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2000),
      },
    },
  });
  const {
    field: {
      value: screenshotUrl,
      onChange: setScreenshotUrl,
      onBlur: validateScreenshotUrl,
    },
    fieldState: { error: screenshotUrlError },
  } = useController({
    control,
    name: 'screenshotUrl',
    rules: {
      validate: {
        isValidInput,
        withValidUrl: createUrlValidator('Invalid Screenshot URL'),
        withValidMaxLength: createMaxLengthValidator(100),
      },
    },
  });
  const {
    field: { value: videoUrl, onChange: setVideoUrl, onBlur: validateVideoUrl },
    fieldState: { error: videoUrlError },
  } = useController({
    control,
    name: 'videoUrl',
    rules: {
      validate: {
        isValidInput,
        withValidUrl: createUrlValidator('Invalid Video URL'),
        withValidMaxLength: createMaxLengthValidator(100),
      },
    },
  });
  const {
    field: {
      value: technicalContactName,
      onChange: setTechnicalContactName,
      onBlur: validateTechnicalContactName,
    },
    fieldState: { error: technicalContactNameError },
  } = useController({
    control,
    name: 'technicalContactName',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(50),
      },
    },
  });
  const {
    field: {
      value: technicalContactJobTitle,
      onChange: setTechnicalContactJobTitle,
      onBlur: validateTechnicalContactJobTitle,
    },
    fieldState: { error: technicalContactJobTitleError },
  } = useController({
    control,
    name: 'technicalContactJobTitle',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(50),
      },
    },
  });
  const {
    field: {
      value: technicalContactEmail,
      onChange: setTechnicalContactEmail,
      onBlur: validateTechnicalContactEmail,
    },
    fieldState: { error: technicalContactEmailError },
  } = useController({
    control,
    name: 'technicalContactEmail',
    rules: {
      validate: {
        isRequired,
        withValidEmail: createEmailValidator('Invalid Technical Contact Email'),
        withValidMaxLength: createMaxLengthValidator(100),
      },
    },
  });

  return {
    actionTriggerMessages,
    setActionTriggerMessages,
    validateActionTriggerMessages,
    actionTriggerMessagesError,
    messageTypes,
    setMessageTypes,
    validateMessageTypes,
    messageTypesError,
    optinFlow,
    setOptinFlow,
    validateOptinFlow,
    optinFlowError,
    optoutFlow,
    setOptoutFlow,
    validateOptoutFlow,
    optoutFlowError,
    screenshotUrl,
    setScreenshotUrl,
    validateScreenshotUrl,
    screenshotUrlError,
    videoUrl,
    setVideoUrl,
    validateVideoUrl,
    videoUrlError,
    technicalContactName,
    setTechnicalContactName,
    validateTechnicalContactName,
    technicalContactNameError,
    technicalContactJobTitle,
    setTechnicalContactJobTitle,
    validateTechnicalContactJobTitle,
    technicalContactJobTitleError,
    technicalContactEmail,
    setTechnicalContactEmail,
    validateTechnicalContactEmail,
    technicalContactEmailError,
  };
};
